<app-close-button *ngIf="!popup" (closeButton)="close()"></app-close-button>
<div class="delivery_date" [ngClass]="{popup_style : popup}">
  <img class="top_arrow_icon" *ngIf="popup" src="assets/images/icons/top_arrow_icon.svg">
  <div class="delivery_date--title">
    {{'navbar.delivery_date.delivery_time_prompt' | translate}}
  </div>
  <div class="delivery_date--content">
    <div *ngFor="let item of state, let i = index" class="items pointer">
      <div class="flex_align_center">
        <label class="radio pointer">
          <input type="radio" class="pointer" name="city"
                 [value]="i"
                 [(ngModel)]="selectedId"
                 (ngModelChange)="select(i)"
          >
          <span class="checkmark" [ngClass]="{checked: selectedId === i}">
              <img src="assets/images/icons/checkbox_icon.svg">
        </span>
        </label>
        <div class="label_text">
          {{('navbar.delivery_date.' + item.key) | translate}}
        </div>
      </div>
      <div *ngIf="selectedId === i && state[i].key === 'by_the_time'">
        <div class="available_days_of_delivery_container flex_between_align_center mt_20">
          <div class="days_month flex_column_center_align_center" *ngFor="let elem of dateData?.slots; let i = index">
            <button class="days_button flex_column_center_align_center br_16 pointer"
                    [ngClass]="{'selected': (i === selectedDayIndex ) }"
                    (click)="showCurrentSlotTime(elem.slots, i)">
              <span class="week_days_name" >{{elem.slots[0].start | toLocalDate:'ddd' :true}}</span>
              <span class="text_title_middle mt_8 bold">{{elem.slots[0].start | toLocalDate:'D' : true}}</span>
            </button>
          </div>
        </div>
        <div class="choose_time_container mt_20">
          <mat-select [(ngModel)]="itemStartValue"  (click)="ccc($event)">
            <mat-option *ngFor="let e of slotList;let i=index" [value]="e.start">
              <div class="flex_align_center">
                <label class="radio bold text_normal_sub pointer">
                  <input type="radio" class="pointer" name="time"
                         [value]="e.start"
                         [(ngModel)]="itemStartValue"
                         (ngModelChange)="detectChange()"
                  >
                  <span class="checkmark" [ngClass]="{checked: (e.start === itemStartValue)}">
                    <img src="assets/images/icons/checkbox_icon.svg">
                  </span>
                </label>
                <div class="ml_16 time">
                  {{e.start | toLocalDate :'HH:mm' : false : true}}
                  - {{e.end | toLocalDate :'HH:mm' : false : true }}
                </div>
              </div>
            </mat-option>
          </mat-select>
          <div class="selected_time_block" (click)="openSelectTimeDialog()">
            <span>
              {{selectedTime?.start | toLocalDate :'HH:mm' : false : true}}
              - {{selectedTime?.end | toLocalDate :'HH:mm' : false : true }}
            </span>
            <img src="assets/images/icons/navbar/arrow_left_icon.svg">
          </div>
        </div>
      </div>
    </div>
    <div class="confirmation_button">
      <button class="pointer" (click)="confirm()">
        {{'buttons.confirm' | translate}}
      </button>
    </div>
  </div>
</div>
